export enum ArrowKeys {
  Up = 'arrowup',
  Right = 'arrowright',
  Down = 'arrowdown',
  Left = 'arrowleft',
}
